// extracted by mini-css-extract-plugin
module.exports = {"root":"SetPasswdForm_root__hs6e2","label":"SetPasswdForm_label__2oAym"};